module.exports = __webpack_public_path__ + "static/media/low_mid.2a960551.png";